exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:767px){.mdl-tabs.responsive-mdl .mdl-tabs__tab-bar{display:block;height:52px;margin:0}.mdl-tabs.responsive-mdl .mdl-tabs__tab-bar>.mdl-tabs__tab{margin:0;width:100%;background-color:#fff;height:0;font-size:14px;text-overflow:ellipsis;white-space:nowrap}.mdl-tabs.responsive-mdl .mdl-tabs__tab-bar>.mdl-tabs__tab.is-active{height:52px;padding:2px 30px 2px 4px;border-bottom:1px solid #e0e0e0}.tab-selector.selecting-tab .mdl-tabs.responsive-mdl .mdl-tabs__tab,.tab-selector.selecting-tab .mdl-tabs.responsive-mdl .mdl-tabs__tab.is-active{padding:2px 4px;height:52px;border-bottom:1px solid #e0e0e0}.tab-selector.selecting-tab .mdl-tabs.responsive-mdl .tab-select-icon>i{-webkit-transform:rotate(90deg);transform:rotate(90deg)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=1!./assets/component/second-menu.vue
// module id = 282
// module chunks = 0